export const Main = () => {
  return (
    <div id="main" className="h-[90vh] main  flex justify-center items-center">
      <div className="flex flex-col justify-center items-center gap-2 ">
        <h1 className="main-title text-6xl font-bold text-white text-center leading-normal ">
          شركة أوشن فيو العقارية
        </h1>
        <p className="sub-title font-semibold text-xl text-gray-300">
          متخصصون في إدارة العقارات
        </p>
      </div>
    </div>
  );
};
